import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App/App';
import { installPrimeTabViewNavScrollFix } from './Helper/Util/primeTabViewNavScrollFix';
import ScrollToTop from './Helper/Util/ScrollToTop';
import './index.scss';
import { persistor, store } from './Redux/store';
import './Style/Icons/fontello/css/fontello.css';
import './Style/Themes/generaltheme.css';

installPrimeTabViewNavScrollFix();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <ScrollToTop>
            <App />
          </ScrollToTop>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
